import styled from 'styled-components';

import { getMarkerStatusColor } from '../constants/Colors';
import { StopStatus } from '../constants/Stops';

export const DriverProgress = styled.div<{ hasStops: boolean }>`
  height: 4px;
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-top: 12px;
  border-radius: 50%;
  background-color: transparent;
`;

export const DriverProgressItem = styled.div<{ status?: StopStatus; routeStatus?: string; enableOpacity?: boolean }>`
  flex: 1;
  margin-right: 1px;
  :first-child {
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
  }
  :last-child {
    margin-right: unset;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
  }
  background-color: ${({
    status,
    routeStatus,
    enableOpacity,
  }: {
    status?: StopStatus;
    routeStatus?: string;
    enableOpacity?: boolean;
  }): string => {
    if (routeStatus === `in_transit` || routeStatus === `not_started` || !enableOpacity) {
      return getMarkerStatusColor(status, `medium`);
    }

    return getMarkerStatusColor(status, `medium`);
  }};
`;
